var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "recipecontainer", staticClass: "-mt-md sm:mt-0" }, [
    _c("div", { staticClass: "mb-lg" }, [
      _c("div", { staticClass: "grid grid-cols-12 gap-md mb-md" }, [
        _c("div", { staticClass: "col-span-12 lg:col-span-6" }, [
          _c(
            "label",
            {
              staticClass: "font-semibold mb-xxs inline-block",
              attrs: { for: "search" },
            },
            [_vm._v("Zoeken")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "relative" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchInput,
                  expression: "searchInput",
                },
              ],
              staticClass:
                "form__input py-[20px] pr-lg px-sm form__input--filled-dark placeholder:text-ellipsis",
              attrs: {
                id: "search",
                name: "search",
                placeholder: "Vul hier een ingrediënt, titel, soort gerecht in",
                type: "text",
              },
              domProps: { value: _vm.searchInput },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchInput = $event.target.value
                  },
                  _vm.searchImmediately,
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "absolute right-sm top-1/2 -translate-y-1/2 text-gray-600 hover:text-gray-400 cursor-pointer",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.search.apply(null, arguments)
                  },
                },
              },
              [_c("i", { staticClass: "fa-regular fa-search" })]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-span-12 lg:col-span-6 lg:order-first" }, [
          _c(
            "label",
            {
              staticClass: "font-semibold mb-xxs inline-block",
              attrs: { for: "search" },
            },
            [_vm._v("Gratis recepten")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "grid grid-cols-2 gap-xs md:gap-0" }, [
            _c(
              "button",
              {
                staticClass:
                  "col-span-2 md:col-span-1 cursor-pointer border border-primary-400 transition-colors uppercase text-sm font-semibold py-[20.6px] text-center flex items-center justify-center select-none",
                class: {
                  "bg-primary-400 text-gray-800": _vm.with_prep,
                  "text-primary-400 hover:bg-primary-400 hover:bg-opacity-10":
                    !_vm.with_prep,
                },
                on: {
                  click: function ($event) {
                    return _vm.setWithPrep(true)
                  },
                },
              },
              [
                _vm._v(
                  "\n                        Gratis recepten op de website\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "col-span-2 md:col-span-1 cursor-pointer border border-primary-400 transition-colors uppercase text-sm font-semibold py-[20.6px] text-center flex items-center justify-center select-none",
                class: {
                  "bg-primary-400 text-gray-800": !_vm.with_prep,
                  "text-primary-400 hover:bg-primary-400 hover:bg-opacity-10":
                    _vm.with_prep,
                },
                on: {
                  click: function ($event) {
                    return _vm.setWithPrep(false)
                  },
                },
              },
              [
                _vm._v(
                  "\n                        Alle recepten uit alle boeken\n                    "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "p",
          {
            staticClass:
              "font-semibold mb-xs inline-flex items-center gap-xs xl:pointer-events-none",
            on: { click: _vm.toggleFiltersVisible },
          },
          [
            _vm._v("\n                Meer zoekopties "),
            _c(
              "span",
              {
                staticClass: "transition-transform xl:hidden",
                class: { "-rotate-180": _vm.filtersVisible },
              },
              [
                _c("i", {
                  staticClass:
                    "fa-regular transition-transform fa-chevron-down",
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "overflow-hidden transition-all xl:!max-h-[initial] xl:transition-none",
            style:
              "max-height: " +
              (_vm.canShowFilter ? _vm.calculatedFiltersHeight : 0) +
              "px;",
          },
          [
            _c(
              "div",
              {
                ref: "filters",
                staticClass:
                  "flex flex-wrap justify-start items-start -m-xs xl:-m-xxs mt-sm",
              },
              _vm._l(_vm.grouped_cats, function (cat_group, index) {
                return _c(
                  "div",
                  {
                    staticClass:
                      "inline-flex flex-wrap p-xs xl:p-xxs gap-xs w-full md:w-1/3 xl:w-1/5 justify-start items-start",
                  },
                  [
                    _c("p", {
                      staticClass:
                        "font-semibold w-full text-xs mb-xxs uppercase",
                      domProps: { innerHTML: _vm._s(cat_group.title.rendered) },
                    }),
                    _vm._v(" "),
                    _vm._l(cat_group.acf.filters, function (cat, index) {
                      return _c("span", {
                        key: index,
                        staticClass:
                          "py-xxs px-xs text-xs uppercase hover:text-primary-400 hover:border-primary-400 text-gray-500 border transition-colors inline-flex border-gray-600 text-opacity-80 tracking-[2px] font-semibold cursor-pointer select-none",
                        class: {
                          "bg-primary-400 !text-gray-800":
                            _vm.active_categories.includes(cat),
                        },
                        domProps: { innerHTML: _vm._s(cat) },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.setCategory(cat)
                          },
                        },
                      })
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "grid gap-y-lg sm:gap-md md:gap-lg lg:gap-xl grid-cols-12",
      },
      [
        _vm.loading
          ? _c(
              "div",
              {
                key: "loading",
                staticClass: "flex col-span-12 justify-center",
              },
              [_vm._m(0)]
            )
          : _vm.recipes.length
          ? _vm._l(_vm.recipes, function (item, index) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "col-span-12",
                  class: {
                    "xs:col-span-6":
                      index == 0 || index == 1 || index == 6 || index == 7,
                    "xs:col-span-5":
                      index == 2 || index == 5 || index == 8 || index == 11,
                    "xs:col-span-7":
                      index == 3 || index == 4 || index == 9 || index == 10,
                  },
                },
                [_c("recipeitem", { attrs: { content: item } })],
                1
              )
            })
          : _c(
              "div",
              {
                staticClass:
                  "col-span-12 text-center flex flex-col items-center",
              },
              [
                _c("p", { staticClass: "mb-sm" }, [
                  _vm._v("Niet gevonden wat je zocht?"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--primary btn--outline",
                    on: {
                      click: function ($event) {
                        return _vm.setWithPrep(!_vm.with_prep)
                      },
                    },
                  },
                  [
                    _vm._v("Zoek in "),
                    _vm.with_prep
                      ? [_vm._v(" alle recepten van alle boeken")]
                      : [_vm._v(" gratis recepten op de website")],
                  ],
                  2
                ),
              ]
            ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-span-12" },
          [
            _c("pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "total-pages": _vm.totalPages,
              },
              on: {
                "next-page": function ($event) {
                  return _vm.filter(_vm.currentPage + 1)
                },
                "previous-page": function ($event) {
                  return _vm.filter(_vm.currentPage - 1)
                },
                "go-to-page": function (event) {
                  return _vm.filter(event.page)
                },
              },
            }),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center",
      },
      [
        _c("i", {
          staticClass:
            "fa-regular fa-spinner-third h-[60px] w-auto animate-spin",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }